export default "__VITE_ASSET__e0819967__"